import { extends as _extends } from "../../../_virtual/_rollupPluginBabelHelpers.js";
import 'react';
import { jsx } from '@emotion/core';
import useDocumentsAppConfigs from "../../../hooks/useDocumentsAppConfigs.js";
import { observer } from 'mobx-react';
import useStores from "../../../hooks/useStores.js";
import FillableManualTextField from "./FillableManualTextField.js";
import FillableMultilineManualTextField from "./FillableMultilineManualTextField.js";
import FillableCheckboxField from "./FillableCheckboxField.js";
import FillableSignatureField from "./FillableSignatureField.js";
import FillableAutofillTextField from "./FillableAutofillTextField.js";
import FillableDateField from "./FillableDateField.js";
var components = {
  manual: {
    string: FillableManualTextField,
    string_multiline: FillableMultilineManualTextField,
    boolean: FillableCheckboxField
  },
  autofill: {
    string: FillableAutofillTextField
  },
  signing: {
    signature: FillableSignatureField,
    initials: FillableSignatureField,
    date: FillableDateField
  }
};

var getComponent = function getComponent(field) {
  var _field$data, _field$data2;

  var dataType = ((_field$data = field.data) === null || _field$data === void 0 ? void 0 : _field$data.dataType) || 'manual';
  var valueType = ((_field$data2 = field.data) === null || _field$data2 === void 0 ? void 0 : _field$data2.valueType) || 'string';

  if (dataType === 'manual' && valueType === 'string' && field.data.multiline) {
    valueType += '_multiline';
  }

  return components[dataType][valueType];
};

var FillableField = function FillableField(props) {
  var field = props.field;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      currentUserId = _useDocumentsAppConfi.currentUserId,
      currentUserPermissions = _useDocumentsAppConfi.currentUserPermissions;

  var Component = getComponent(field);

  var handleFieldSelection = function handleFieldSelection(e) {
    e.stopPropagation();
    pdfStore.setSelectedFields([field]);
    pdfStore.ensureNextPrevFieldPagesAreRendered(currentUserId, currentUserPermissions);
  };

  return jsx(Component, _extends({
    onMouseDown: function onMouseDown(e) {
      return e.stopPropagation();
    },
    onFocus: handleFieldSelection,
    onClick: handleFieldSelection
  }, props));
};

FillableField.displayName = "FillableField";
var FillableField$1 = observer(FillableField);
export default FillableField$1;